export const removeNest = (targetObject: any) => {
  let result: any = {};
  Object.keys(targetObject).forEach((ele) => {
    if (
      typeof targetObject[ele] === "object" &&
      !Array.isArray(targetObject[ele])
    ) {
      const nestRemovedObjct = removeNest(targetObject[ele]);
      result = { ...result, ...nestRemovedObjct };
    } else {
      result[ele] = targetObject[ele];
    }
  });
  return result;
};

/**
 * enumに含まれるか判定
 */
export const isEnumValue = (enumObject: any, value: any) => {
  if (value === undefined || value === null) {
    return false;
  }
  return Object.values(enumObject).includes(value);
};

/**
 * booleanかどうか判定
 */
export const isBoolean = (value: any) => {
  if (value === undefined) {
    return false;
  }
  return typeof value === "boolean";
};
